import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { Section } from './Shared';
export const FAQ = () => {
  const faqs = [{
    q: '¿Esto funciona aunque no tenga experiencia en rituales?',
    a: 'Sí. El sistema fue diseñado específicamente para personas que nunca hicieron una limpieza energética en su vida. Cada ritual tiene el paso a paso exacto, con los elementos precisos y las palabras que hay que decir. No necesitás saber nada previo.'
  }, {
    q: '¿Qué necesito comprar para aplicar esto?',
    a: 'Casi nada. El 90% de los rituales usan elementos que ya tenés en tu casa: sal, vinagre, café, azúcar, yerba mate, ajo. En los casos donde se necesita algo extra, siempre es algo que conseguís en cualquier almacén o supermercado por menos de $500.'
  }, {
    q: '¿En cuánto tiempo veo resultados?',
    a: 'Depende del nivel de bloqueo de cada persona. Algunos reportan cambios en 48 horas. Otros en una semana. Lo que es seguro es que no podés esperar resultados diferentes si seguís haciendo exactamente lo mismo.'
  }, {
    q: '¿Recibo acceso inmediato?',
    a: 'Sí. Apenas confirmás el pago recibís el link de descarga directamente en tu email. En menos de 5 minutos tenés todo el material disponible para empezar.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. Tenés 7 días completos para revisar todo el material, aplicar los rituales y comprobar por vos mismo si funciona. Si no estás satisfecho por cualquier motivo, te devolvemos el 100% de tu dinero sin preguntas ni formularios.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="max-w-3xl" data-id="element-72">
      <div className="text-center mb-12" data-id="element-73">
        <h2 className="md:text-4xl font-display font-bold mb-4 flex items-center justify-center text-[22px] text-brand-darkGreen" data-id="element-74">
          <span className="mr-3" data-id="element-75">❓</span> PREGUNTAS FRECUENTES
        </h2>
      </div>

      <div className="space-y-4" data-id="element-76">
        {faqs.map((faq, i) => <div key={i} className="glass-panel rounded-2xl overflow-hidden border-brand-gold/25 bg-white/80" data-id="element-77">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none hover:bg-brand-surfaceLight/60 transition-colors" data-id="element-78">
              <span className="font-medium pr-8 text-brand-darkGreen text-[14px] md:text-base lg:text-lg" data-id="element-79">
                {faq.q}
              </span>
              <ChevronDown className={`w-5 h-5 text-brand-goldDark transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-80" />
            </button>
            <AnimatePresence data-id="element-81">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-82">
                  <div className="px-6 pb-5 text-brand-text border-t border-brand-gold/20 pt-4 bg-white/60 text-[13px] md:text-base leading-relaxed" data-id="element-83">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
};